(function () {
  /* ---- intro animation: once per browser session ---- */
  var intro = document.getElementById('intro');
  if (intro) {
    var seen = false;
    try { seen = sessionStorage.getItem('tpl-intro') === '1'; } catch (e) {}
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (seen) {
      intro.remove();
      document.body.classList.remove('loading');
    } else {
      setTimeout(function () {
        intro.classList.add('done');
        document.body.classList.remove('loading');
        try { sessionStorage.setItem('tpl-intro', '1'); } catch (e) {}
        setTimeout(function () { if (intro.parentNode) intro.remove(); }, 800);
      }, reduce ? 400 : 2000);
    }
  }

  /* ---- mobile nav ---- */
  var btn = document.getElementById('menubtn');
  var nav = document.getElementById('mobilenav');
  if (btn && nav) {
    btn.addEventListener('click', function () {
      var open = nav.classList.toggle('open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---- product variant picker: live price ---- */
  var pdpForm = document.getElementById('pdp-form');
  var pdpPrice = document.getElementById('pdp-price');
  if (pdpForm && pdpPrice) {
    pdpForm.addEventListener('change', function (e) {
      if (e.target.name === 'id' && e.target.dataset.price) {
        pdpPrice.textContent = e.target.dataset.price;
      }
    });
  }

  /* ---- cart: apply a discount code via Shopify's /discount/ route ---- */
  var codeForm = document.getElementById('codeform');
  if (codeForm) {
    codeForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = document.getElementById('codeinput');
      var code = (input.value || '').trim();
      if (!code) { input.focus(); return; }
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
    });
  }

  /* ---- school quote form: fold every answer into the message body ---- */
  var quoteForm = document.getElementById('school-quote');
  if (quoteForm) {
    quoteForm.addEventListener('submit', function () {
      var body = quoteForm.querySelector('textarea[name="contact[body]"]');
      if (!body) return;
      var lines = [];
      quoteForm.querySelectorAll('input, select').forEach(function (el) {
        var n = el.getAttribute('name');
        if (!n || n.indexOf('contact[') !== 0) return;
        if (n === 'contact[email]' || n === 'contact[body]') return;
        if ((el.type === 'radio' || el.type === 'checkbox') && !el.checked) return;
        var label = n.replace('contact[', '').replace(']', '');
        var val = (el.value || '').trim();
        if (val) lines.push(label + ': ' + val);
      });
      if (lines.length) body.value = lines.join('\n') + '\n\nNotes: ' + body.value;
    });
  }

  /* ---- scroll to the confirmation after a successful submit ---- */
  var sent = document.getElementById('quote-sent');
  if (sent) {
    sent.scrollIntoView({ behavior: 'smooth', block: 'center' });
    sent.focus();
  }

  /* ---- scroll reveal ---- */
  var reveals = document.querySelectorAll('.reveal');
  if (reveals.length) {
    if (!('IntersectionObserver' in window) ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      reveals.forEach(function (el) { el.classList.add('in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      reveals.forEach(function (el) { io.observe(el); });
    }
  }

  /* ---- smooth scroll for same-page anchors ---- */
  document.querySelectorAll('a[href*="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var href = a.getAttribute('href');
      var parts = href.split('#');
      if (parts.length < 2 || !parts[1]) return;
      if (parts[0] && parts[0] !== window.location.pathname) return;
      var target = document.getElementById(parts[1]);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
        if (nav) nav.classList.remove('open');
      }
    });
  });

  /* ---- cookie banner ----
     Only shown when the theme setting is on. It records the visitor's choice
     and hands it to Shopify's Customer Privacy API when that API is present,
     so analytics/marketing cookies stay off until the visitor agrees. */
  var bar = document.getElementById('cookiebar');
  if (bar) {
    var KEY = 'tpl-consent';
    var stored = null;
    try { stored = localStorage.getItem(KEY); } catch (e) {}

    function apply(granted) {
      try { localStorage.setItem(KEY, granted ? 'granted' : 'denied'); } catch (e) {}
      bar.classList.remove('show');
      if (window.Shopify && window.Shopify.customerPrivacy &&
          typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function') {
        try {
          window.Shopify.customerPrivacy.setTrackingConsent({
            analytics: granted, marketing: granted, preferences: granted,
            sale_of_data: granted
          }, function () {});
        } catch (e) {}
      }
    }

    if (!stored) {
      bar.classList.add('show');
    }
    var ok = document.getElementById('cb-accept');
    var no = document.getElementById('cb-decline');
    if (ok) ok.addEventListener('click', function () { apply(true); });
    if (no) no.addEventListener('click', function () { apply(false); });
  }
})();
